const filterUsersByName = (users, searchTerm = "") => {
  const terms = searchTerm.trim().toLowerCase().split(/\s+/).filter(Boolean);
  const userList = users ?? [];

  if (terms.length === 0) return userList;

  return userList.filter(({ user }) => {
    const fullName = `${user?.first_name || ""} ${user?.last_name || ""}`.toLowerCase();
    return terms.every((term) => fullName.includes(term));
  });
};

export default filterUsersByName;
